import { OnInit } from '@angular/core';
import { OrderService } from '../../shared/services/order.service';
var OrderHistoryComponent = /** @class */ (function () {
    function OrderHistoryComponent(orderService) {
        this.orderService = orderService;
        this._orders = [];
        this._isLoaded = false;
    }
    OrderHistoryComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.orderService.getOrderHistory().then(function (orders) {
            _this._orders = orders;
            _this._isLoaded = true;
        })
            .catch(function (error) {
            console.error(error);
        });
    };
    OrderHistoryComponent.prototype.hasMoreResults = function () {
        return this.orderService.hasMoreResults();
    };
    OrderHistoryComponent.prototype.loadMore = function () {
        var _this = this;
        this.orderService.loadMore().then(function (orders) { return _this._orders = orders; });
    };
    Object.defineProperty(OrderHistoryComponent.prototype, "isLoaded", {
        get: function () {
            return this._isLoaded;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderHistoryComponent.prototype, "hasOrders", {
        get: function () {
            return this._orders && this._orders.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrderHistoryComponent.prototype, "orders", {
        get: function () {
            return this._orders;
        },
        enumerable: true,
        configurable: true
    });
    return OrderHistoryComponent;
}());
export { OrderHistoryComponent };



// WEBPACK FOOTER //
// ./src/app/admin/order-history/order-history.component.ts.pre-build-optimizer.js